// Generated by purs version 0.15.16
import * as API_Account from "../API.Account/index.js";
import * as API_Document from "../API.Document/index.js";
import * as API_FormType from "../API.FormType/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as $$Error from "../Error/index.js";
import * as GraphQL_Join from "../GraphQL.Join/index.js";
import * as GraphQL_Query from "../GraphQL.Query/index.js";
import * as GraphQL_Type from "../GraphQL.Type/index.js";
import * as Internal_SelectionMap from "../Internal.SelectionMap/index.js";
import * as Steps_WorkQueue_DocumentIndex from "../Steps.WorkQueue.DocumentIndex/index.js";
var show = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Data_Show.showArray(Data_Show.showString));
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var ordRNTY = /* #__PURE__ */ GraphQL_Type.ordRNTY(Data_Ord.ordString);
var selectAll$prime = /* #__PURE__ */ Internal_SelectionMap["selectAll$prime"](ordRNTY)(Data_Functor.functorArray)(Data_Foldable.foldableArray);
var isEmpty = /* #__PURE__ */ Internal_SelectionMap.isEmpty(ordRNTY);
var fromFoldable = /* #__PURE__ */ Data_Array.fromFoldable(Data_List_Types.foldableList);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_List_Types.functorList);
var eq = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ GraphQL_Type.eqRNTY(Data_Eq.eqString));
var append1 = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var runGraphQL = /* #__PURE__ */ GraphQL_Join.runGraphQL(GraphQL_Query.qgql);
var showFQE = function (v) {
    if (v.form instanceof Data_Either.Right) {
        return "{ student: " + (GraphQL_Type.innerId(v.student) + (", form: " + (GraphQL_Type.innerId(v.form.value0) + " }")));
    };
    if (v.form instanceof Data_Either.Left) {
        return "{ student: " + (GraphQL_Type.innerId(v.student) + (", form: " + (GraphQL_Type.innerId(v.form.value0.form_type.id) + " }")));
    };
    throw new Error("Failed pattern match at Steps.WorkQueue.State (line 193, column 1 - line 193, column 36): " + [ v.constructor.name ]);
};
var showFillQueue = function (fq) {
    return show(map(showFQE)(fq));
};
var setTeacherAndSemester = function (workQ) {
    return function (teacher) {
        return function (semester) {
            return {
                forms: workQ.forms,
                students: workQ.students,
                documents: workQ.documents,
                editDocs: workQ.editDocs,
                currentDoc: workQ.currentDoc,
                teacher: teacher,
                semester: new Data_Maybe.Just(semester)
            };
        };
    };
};
var setCurrentDoc = function (workQ) {
    return function (doc) {
        return {
            forms: workQ.forms,
            students: workQ.students,
            documents: workQ.documents,
            editDocs: workQ.editDocs,
            semester: workQ.semester,
            teacher: workQ.teacher,
            currentDoc: doc
        };
    };
};
var resetWorkQueueState = function (defTeacher) {
    return function (defSemester) {
        return function (workQ) {
            return {
                forms: API_FormType.emptyFormPickerMap,
                students: Internal_SelectionMap.empty,
                documents: Steps_WorkQueue_DocumentIndex.emptyDocMap,
                editDocs: [  ],
                currentDoc: Data_Maybe.Nothing.value,
                teacher: defTeacher,
                semester: defSemester
            };
        };
    };
};
var removeStudents = function (workQ) {
    return function (students) {
        return {
            forms: workQ.forms,
            documents: workQ.documents,
            editDocs: workQ.editDocs,
            currentDoc: workQ.currentDoc,
            semester: workQ.semester,
            teacher: workQ.teacher,
            students: selectAll$prime(students)(workQ.students)(false)
        };
    };
};
var isWorkQueueEmpty = function (v) {
    return (isEmpty(v.forms) || isEmpty(v.students)) && Data_Array.length(v.editDocs) <= 0;
};
var initialWorkQueueState = /* #__PURE__ */ (function () {
    return {
        forms: API_FormType.emptyFormPickerMap,
        students: Internal_SelectionMap.empty,
        documents: Steps_WorkQueue_DocumentIndex.emptyDocMap,
        editDocs: [  ],
        currentDoc: Data_Maybe.Nothing.value,
        teacher: Data_Maybe.Nothing.value,
        semester: Data_Maybe.Nothing.value
    };
})();
var getTeacher = function (v) {
    return v.teacher;
};
var getTeacherOrErr = function (workQ) {
    var err = new $$Error.StringError("No teacher selected to fill forms for.");
    return Data_Either.note(err)(getTeacher(workQ));
};
var getSemester = function (v) {
    return v.semester;
};
var getSemesterOrErr = function (workQ) {
    var err = new $$Error.StringError("No semester selected to fill forms for.");
    return Data_Either.note(err)(getSemester(workQ));
};
var getFillQueue = function (workQ) {
    var students = fromFoldable(map1(function (v) {
        return v.id;
    })(Internal_SelectionMap.listSelected(workQ.students)));
    var forms = fromFoldable(map1(function (v) {
        return v.id;
    })(Internal_SelectionMap.listSelected(workQ.forms)));
    var studentForms = function (student) {
        var docs = map(Data_Either.Left.create)(Data_Array.filter(function (f) {
            return eq(f.student.id)(student);
        })(workQ.editDocs));
        return map(function (f) {
            return {
                student: student,
                form: f
            };
        })(append1(docs)(map(Data_Either.Right.create)(forms)));
    };
    return Data_Array.concat(map(studentForms)(students));
};
var formForSelected$prime = function (v) {
    return Data_Maybe.isJust(v.teacher) && Data_Maybe.isJust(v.semester);
};
var formForSelected = function (v) {
    return function (v1) {
        if (v.type instanceof API_Account.BoardAccount) {
            return Data_Maybe.isJust(v1.semester);
        };
        return formForSelected$prime(v1);
    };
};
var fillQueueToCreateReq = function (v) {
    return function (v1) {
        return function (v2) {
            if (v2.form instanceof Data_Either.Right) {
                return new Data_Maybe.Just({
                    student_id: v2.student,
                    type_id: v2.form.value0,
                    teacher_id: map2(function (v3) {
                        return v3.id;
                    })(v),
                    semester: map2(function (v3) {
                        return v3.semester;
                    })(v1)
                });
            };
            if (v2.form instanceof Data_Either.Left) {
                return Data_Maybe.Nothing.value;
            };
            throw new Error("Failed pattern match at Steps.WorkQueue.State (line 177, column 1 - line 181, column 31): " + [ v.constructor.name, v1.constructor.name, v2.constructor.name ]);
        };
    };
};
var editDocsWorkQueue = function (workQ) {
    return function (docs) {
        return {
            forms: workQ.forms,
            documents: workQ.documents,
            currentDoc: workQ.currentDoc,
            semester: workQ.semester,
            teacher: workQ.teacher,
            editDocs: docs,
            students: selectAll$prime(map(function (v1) {
                return v1.student;
            })(docs))(workQ.students)(true)
        };
    };
};
var createAllForms = function (workQ) {
    return function (defTeacher) {
        return function (defSemester) {
            return runGraphQL(API_Document.createAndExport(Data_Array.catMaybes(map(fillQueueToCreateReq(defTeacher)(defSemester))(getFillQueue(workQ)))));
        };
    };
};
var addStudents = function (workQ) {
    return function (students) {
        return {
            forms: workQ.forms,
            documents: workQ.documents,
            editDocs: workQ.editDocs,
            currentDoc: workQ.currentDoc,
            semester: workQ.semester,
            teacher: workQ.teacher,
            students: selectAll$prime(students)(workQ.students)(true)
        };
    };
};
export {
    initialWorkQueueState,
    resetWorkQueueState,
    formForSelected,
    formForSelected$prime,
    isWorkQueueEmpty,
    addStudents,
    removeStudents,
    getTeacher,
    getTeacherOrErr,
    getSemester,
    getSemesterOrErr,
    setTeacherAndSemester,
    setCurrentDoc,
    editDocsWorkQueue,
    showFillQueue,
    getFillQueue,
    createAllForms
};
//# sourceMappingURL=index.js.map
